<template>
  <page-info>
    <template v-slot:content>
      <div class="order-payOk">
        <div class="order-wrap">
          <i v-if="isPayOk" class="icon-success el-icon-success"></i>
          <i v-if="!isPayOk" class="icon-error el-icon-error"></i>
          <div class="pay-txt">{{isPayOk?'完成支付':'支付失败'}}</div>
          <div class="btn-back" @click="goBackHome()">返回首页({{timeCountDown}}秒后自动返回)</div>
        </div>

      </div>
    </template>
  </page-info>

</template>
<script>
    import PageInfo from '../../layout/pageInfo/index.vue'
  export default {
      data(){
          return {
              isPayOk:true,
              timeCountDown:5,
              timer:null
          }
      },
      components:{
          PageInfo
      },
      computed:{

      },
      created () {

      },
      mounted(){
          this.setTimeCountDown()
      },
      beforeDestroy(){
          clearTimeout(this.timer);
      },
      methods:{
          setTimeCountDown(){
              let that = this ;
              this.timer = setTimeout(function () {
                  if(that.timeCountDown==0){
                      that.timer=null;
                      that.$router.push({path:'/index'})
                      return ;
                  }
                  that.timeCountDown--;
                  that.setTimeCountDown()

              },1000)
          },
          goBackHome(){
              this.$router.push('/index')
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/common";
  .order-payOk{
    min-height:550px;
    text-align: center;
    display: table;
    width:100%;
    .order-wrap{
      display: table-cell;
      vertical-align: middle;
    }
    .btn-back{
      margin-top:20px;
      text-decoration: underline;
      line-height:30px;
    }
    .icon-success{
      color: $main-color;
      font-size:100px;
    }
    .icon-error{
      color:red;
      font-size:100px;
    }
    .pay-txt{
      padding-top:20px;
      font-size: 24px;
    }
    .btn-back{
      font-size:18px;
    }
  }
</style>
<style lang="scss">
  @import "../../../assets/css/common";

</style>

